import { t } from "@/i18n-js/instance";
import type { Plan } from "@circle-react/types";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { AiActionsSection } from "./AiActionsSection";
import { AiFiltersSection } from "./AiFiltersSection";
import { PlanCard } from "./PlanCard";

interface LeftSideProps {
  handleActivate: () => void;
  handleLearnMore: () => void;
  isPlanLoading: boolean;
  plan: Plan;
}

export const LeftSide = ({
  handleActivate,
  handleLearnMore,
  isPlanLoading,
  plan,
}: LeftSideProps) => (
  <div className="flex flex-1 flex-col">
    <div className="mb-4">
      <Typography.BodyMd>
        {t("settings.ai_actions.modal.description")}
      </Typography.BodyMd>
    </div>
    <AiFiltersSection />
    <AiActionsSection />
    <Button
      onClick={handleLearnMore}
      variant="secondary"
      className="mb-4 w-auto self-start"
    >
      {t("settings.ai_actions.modal.learn_more_button")}
      <Icon type="16-arrow-top-right" size={16} className="ml-2" />
    </Button>
    <div className="mt-auto flex flex-col gap-4">
      <div className="lg:hidden">
        <PlanCard plan={plan} isLoading={isPlanLoading} />
      </div>
      <Button onClick={handleActivate} large full variant="marketing-gradient">
        {t("settings.ai_actions.modal.upgrade_to", {
          plan_name: "Enterprise",
        })}
      </Button>
    </div>
  </div>
);
